import { createApp, h } from 'vue'
import persist from '@/plugins/persist'
import App from './App.vue'
import router from './router/index'
import store from './store'
import { createPinia } from 'pinia'
import { useUserStore } from '@/stores/userStore'

import "./assets/css/custom.bootstrap.scss";

// Custom Input Components
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/style.css'
import CustomScrollbar from 'custom-vue-scrollbar';
import 'custom-vue-scrollbar/dist/style.css';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import uploader from 'vue-simple-uploader'
import 'vue-simple-uploader/dist/style.css'

import "./assets/css/main.css";

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Add SVG Core
import { library } from '@fortawesome/fontawesome-svg-core'
import folderOpenIcon from '@/assets/images/icons/arrow-down.svg'

// Free icon
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

// Multilingual
import i18n from "./i18n"

library.add(fas, fab, far)

const FolderOpenIcon = {
    render() {
      return h('svg', { 
        class: 'vs-drop-icon', 
        innerHTML: `<use href="${folderOpenIcon}#icon"></use>`
      })
    }
  }

vSelect.props.components.default = () => ({
    Deselect: {
      render: () => h('span', '❌'),
    },
    OpenIndicator: {
      render: () => h(FolderOpenIcon),
    }
})

const pinia = createPinia()
pinia.use(persist)

let app = createApp(App)
    .use(i18n)
    .use(store)
    .use(pinia)
    .use(uploader)
    .use(PerfectScrollbarPlugin)
    .component("font-awesome-icon", FontAwesomeIcon)
    .component(CustomScrollbar.name, CustomScrollbar)
    .component('vSelect', vSelect)

const userStore = useUserStore()

userStore.autoLogin().then(() => {
  app.use(router)
  app.mount('#page-wrap')
})